import { render, staticRenderFns } from "./HowToEarn.vue?vue&type=template&id=0e988f63&scoped=true"
import script from "./HowToEarn.vue?vue&type=script&lang=js"
export * from "./HowToEarn.vue?vue&type=script&lang=js"
import style0 from "./HowToEarn.vue?vue&type=style&index=0&id=0e988f63&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e988f63",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e988f63')) {
      api.createRecord('0e988f63', component.options)
    } else {
      api.reload('0e988f63', component.options)
    }
    module.hot.accept("./HowToEarn.vue?vue&type=template&id=0e988f63&scoped=true", function () {
      api.rerender('0e988f63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P2_Page/Invite/components/HowToEarn.vue"
export default component.exports